import React from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const CancelPage = () => {
    const navigate = useNavigate();

    return (
        <Container fluid className="h-100 mt-5 pt-5">
            <Row className="justify-content-center align-items-center h-100">
                <Col md={6}>
                    <Card className="shadow-sm">
                        <Card.Body className="p-5 text-center">
                            <h2 className="text-warning mb-4">Pagamento Annullato</h2>
                            <p className="mb-5 text-muted">
                                Il processo di pagamento è stato interrotto. L'abbonamento non è stato attivato.
                            </p>
                            <Button 
                                variant="primary" 
                                size="lg" 
                                onClick={() => navigate('/abbonamento', { replace: true })}
                            >
                                Riprova l'acquisto
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CancelPage;